module.exports = "/_next/static/images/AdaptImage-8b631063e827fea507103c40a60fdc43.webp";